import React from 'react'

const Input = ({ className, id, type, required, disabled, label, handleChange, changeEvent, step, value, handleBlur }) => {
	
	const randomId = `input__${Math.floor(Math.random() * 1000)}`

	const change = e => { 
		if (changeEvent === false) {
			return
		}
		handleChange(e)
	}
	const blur = e => { 
		if (!handleBlur) {
			return handleChange(e)

		}
		return handleBlur(e)
	}

	return (
		<div className={className ? `${className} no__input-group` : 'no__input-group'}>
			<label htmlFor={id || randomId}>{label}{required && '*'}</label>
			<input
				type={type || 'text'}
				id={id || randomId}
				required={required || false}
				disabled={disabled || false}
				onBlur={blur}
				value={value}
				onChange={change}
				step={step || 1}
			/>
		</div>
	)
}

export default Input
